export default class {
  init() {
    const $elements = $("section.gallery-grid .masonry-grid");

    if ($elements.length) {
      (async () => {
        const Masonry = (await import("masonry-layout")).default;

        [...$elements].forEach((el) => {
          // eslint-disable-next-line
          new Masonry(el);
        });
      })();
    }
  }
}
